define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FacilityInspStatusDomain = void 0;
    class FacilityInspStatusDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: FacilityInspStatusDomain.Draft, value: "Draft" },
                    { key: FacilityInspStatusDomain.PendingReview, value: "Pending Review" },
                    { key: FacilityInspStatusDomain.Refused, value: "Refused" },
                    { key: FacilityInspStatusDomain.Cancelled, value: "Cancelled" },
                    { key: FacilityInspStatusDomain.Confirmed, value: "Confirmed" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[FacilityInspStatusDomain.Draft] = 0;
                this.KeyIndex[FacilityInspStatusDomain.PendingReview] = 1;
                this.KeyIndex[FacilityInspStatusDomain.Refused] = 2;
                this.KeyIndex[FacilityInspStatusDomain.Cancelled] = 3;
                this.KeyIndex[FacilityInspStatusDomain.Confirmed] = 4;
                this.ValueIndex = {};
                this.ValueIndex["Draft"] = 0;
                this.ValueIndex["Pending Review"] = 1;
                this.ValueIndex["Refused"] = 2;
                this.ValueIndex["Cancelled"] = 3;
                this.ValueIndex["Confirmed"] = 4;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.FacilityInspStatusDomain = FacilityInspStatusDomain;
    Object.defineProperty(FacilityInspStatusDomain, "Draft", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(FacilityInspStatusDomain, "PendingReview", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(FacilityInspStatusDomain, "Refused", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(FacilityInspStatusDomain, "Cancelled", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(FacilityInspStatusDomain, "Confirmed", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(FacilityInspStatusDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
